export const CURRENCY_ISO_OPTIONS = [
  'USD',
  'EUR',
  'GBP',
  'COP',
  'MXN',
  'BRL',
  'ARS',
  'CLP',
  'PEN'
];

